import React from "react";
import SEO from "../../components/SEO";

export default function OurStory() {
  return (
    <>
      <SEO
        title="Our Story | Sugar Society Sugar Cookies"
        description="Learn about the story behind Sugar Society Sugar Cookies, a black-owned small business creating beautifully designed custom cookies in Houston, TX."
        pathname="/our-story"
      />
      <section className="our-story-section">
        <h1>Our Story</h1>
        <article>
          <h2>Once Upon A Time...</h2>
          <div>
            <p>Coming Soon...</p>
          </div>
        </article>
      </section>
    </>
  );
}
